import { Zap, Wallet, TrendingUp, TrendingDown, AlertTriangle } from "lucide-react";
import { fmtUsd } from "@/lib/api";
import { cn } from "@/lib/utils";

const pnlColor = (v) => (v > 0 ? "text-[var(--pos)]" : v < 0 ? "text-[var(--neg)]" : "text-[var(--text-dim)]");

export const FuturesWalletCard = ({ data }) => {
  if (!data || !data.connected) return null;
  const upnl = data.unrealised_pnl || 0;
  const positions = data.positions || [];
  return (
    <div data-testid="futures-wallet-card" className="rounded-lg border border-[#FFB020]/30 bg-[var(--app-bg)] overflow-hidden">
      <div className="flex items-center gap-2.5 px-5 h-14 border-b border-[var(--border)]">
        <div className="h-8 w-8 rounded-md flex items-center justify-center border border-[#FFB020]/40 bg-[#FFB020]/10">
          <Zap className="h-4 w-4 text-[var(--warn)]" />
        </div>
        <h3 className="font-head font-bold text-base">Gate.io Vadeli Cüzdan</h3>
        <span className="ml-auto text-[10px] font-bold px-2 py-0.5 rounded bg-[#FFB020]/15 text-[var(--warn)] border border-[#FFB020]/30">GERÇEK</span>
      </div>
      <div className="p-5 space-y-4">
        {data.error ? (
          <p data-testid="futures-wallet-error" className="flex items-start gap-1.5 text-[12px] text-[#FFD98A] rounded-md bg-[#FFB020]/10 border border-[#FFB020]/25 px-3 py-2.5">
            <AlertTriangle className="h-4 w-4 flex-shrink-0 mt-0.5" /> {data.error}
          </p>
        ) : (
          <>
            <div className="grid grid-cols-3 gap-3">
              <div>
                <span className="text-[11px] text-[var(--text-faint)] flex items-center gap-1"><Wallet className="h-3 w-3" />Toplam</span>
                <span data-testid="futures-total" className="block font-mono font-bold text-[var(--text-primary)] text-sm mt-0.5">{fmtUsd(data.total)}</span>
              </div>
              <div>
                <span className="text-[11px] text-[var(--text-faint)]">Kullanılabilir</span>
                <span data-testid="futures-available" className="block font-mono font-bold text-[var(--pos)] text-sm mt-0.5">{fmtUsd(data.available)}</span>
              </div>
              <div>
                <span className="text-[11px] text-[var(--text-faint)]">Açık K/Z</span>
                <span data-testid="futures-upnl" className={cn("block font-mono font-bold text-sm mt-0.5", pnlColor(upnl))}>
                  {upnl >= 0 ? "+" : ""}{fmtUsd(upnl)}
                </span>
              </div>
            </div>

            <div>
              <div className="text-[11px] text-[var(--text-dim)] uppercase tracking-wider mb-2">Açık Kaldıraçlı Pozisyonlar</div>
              {positions.length === 0 ? (
                <p className="text-[11px] text-[var(--text-faint)] py-1">Açık gerçek vadeli pozisyon yok.</p>
              ) : (
                <div className="space-y-2" data-testid="futures-positions-list">
                  {positions.map((p) => {
                    const long = p.side === "LONG";
                    return (
                      <div key={p.symbol} data-testid={`futures-pos-${p.symbol}`} className="flex items-center gap-2 rounded-md border border-[var(--border)] bg-[var(--surface)] px-3 py-2">
                        <span className={cn("flex items-center gap-1 text-[11px] font-bold px-1.5 py-0.5 rounded", long ? "bg-[#00FFA3]/10 text-[var(--pos)]" : "bg-[#FF3366]/10 text-[var(--neg)]")}>
                          {long ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}{p.side}
                        </span>
                        <span className="font-mono font-bold text-sm">{p.symbol}</span>
                        <span className="text-[10px] font-mono text-[var(--warn)]">x{p.leverage}</span>
                        <div className="ml-auto text-right">
                          <span className={cn("block font-mono text-sm font-bold", pnlColor(p.unrealised_pnl))}>
                            {p.unrealised_pnl >= 0 ? "+" : ""}{fmtUsd(p.unrealised_pnl)}
                          </span>
                          <span className="block text-[10px] font-mono text-[var(--text-faint)]">Giriş ${p.entry_price} · Mark ${p.mark_price}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
